import { useCallback, useEffect, useRef, useState } from 'react'

const FLASH_DURATION_MS = 1600

export function useFlashSublistItem() {
  const [flashId, setFlashId] = useState<string | null>(null)
  const timerRef = useRef<NodeJS.Timeout | undefined>(undefined)

  const clear = useCallback(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current)
      timerRef.current = undefined
    }
    setFlashId(null)
  }, [])

  const flash = useCallback((id: string) => {
    setFlashId(id)

    if (timerRef.current) {
      clearTimeout(timerRef.current)
    }

    timerRef.current = setTimeout(() => {
      timerRef.current = undefined
      setFlashId(null)
    }, FLASH_DURATION_MS)
  }, [])

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current)
      }
    }
  }, [])

  return { flashId, flash, clear }
}
